export const locations = {
    SEARCH_BROWSE: 'SEARCH_BROWSE',
} as const;

export const authLabels = {
    [locations.SEARCH_BROWSE]: 'save search - search/browse page',
} as const;
